import axios from "axios";
import config from "../config";

const requestOptions = { preventLoading: true };

export function createAiAssistantClient(client) {
  if (client.interceptors?.request?.use) {
    client.interceptors.request.use((requestConfig) => {
      const token = localStorage.getItem("token");
      if (token) requestConfig.headers = { ...requestConfig.headers, Authorization: `Bearer ${token}` };
      requestConfig.preventLoading = true;
      return requestConfig;
    });
  }
  return client;
}

export function createAiAssistantService(client) {
  return {
  openSession: (dealId, newConversation = false) => client.post(config.aiAssistantSessionsEndpoint, {
    schemaVersion: "AiAssistantSessionOpenV1",
    dealId,
    ...(newConversation ? { newConversation: true } : {})
  }, requestOptions).then((response) => response.data),

  sendTurn: (payload) => client.post(config.aiAssistantTurnsEndpoint, payload, requestOptions).then((response) => response.data),

  saveFeedback: (payload) => client.post(config.aiAssistantFeedbackEndpoint, payload, requestOptions).then((response) => response.data),

  getHistory: (dealId, beforeSeq) => client.get(config.aiAssistantHistoryEndpoint + "?dealId=" + encodeURIComponent(dealId) + (beforeSeq ? "&beforeSeq=" + encodeURIComponent(beforeSeq) : ""), requestOptions).then((response) => response.data)
  };
}

const aiAssistantService = createAiAssistantService(createAiAssistantClient(axios.create()));

export default aiAssistantService;
